module.exports = __webpack_public_path__ + "img/BG4.837f0852.png";